<template>
  <div id="sections">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToProjectsList" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>            
        </v-flex>
      </v-layout>
    </v-container>
     <v-container class="pa-0">
       <v-card class="mt-3">
      <v-tabs class="xs12" style="width:100%" hide-slider grow v-model="mainTab">
        <v-tabs-slider color="#019d8c"></v-tabs-slider>
          <v-tab v-for="(item, i) of listType" :href="`#tab-${i}`" :key="item" class="justify-space-around" :class="[item === 'Log Information' ? 'border_left_right' : '']">
              {{item}}
          </v-tab>
        <v-tab-item
          v-for="(item, index) in listType"
          :value="`tab-${index}`"
          :key="index">
          <v-container class="pa-0" v-if="index === 2">
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="searchDeviceInfo"
                  append-icon="search"
                  label="Search by Brand / Model / OS"
                  hide-details
                ></v-text-field>
                 <v-spacer></v-spacer>
                 <v-spacer></v-spacer>
                 <v-spacer></v-spacer>
            </v-card-title>
              <v-data-table
                :headers="deviceInfoHeaders"
                :items="accountData"
                :search="searchDeviceInfo"
                class="pf-data-table"
                ref="sortableTable"
                :pagination.sync="paginationInfo"
                no-data-text="No Info to show"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>{{ !props.item.device_info ? 'Desktop' : 'Mobile'}}</td>
                    <td>{{ props.item.device_info ? props.item.device_info.brand : '--'}}</td>
                    <td>{{ props.item.device_info ? props.item.device_info.model : '--'}}</td>
                    <td>{{ props.item.device_info ? props.item.device_info.memory : '--' }} {{ props.item.device_info && props.item.device_info.free_space ? `(${props.item.device_info.free_space})` : '' }}</td>
                    <td align="center">{{ props.item.device_info && props.item.device_info.os ? props.item.device_info.os : '--' }} {{ (props.item.device_info && props.item.device_info.os_version ? `(${props.item.device_info.os_version})` : '') }}</td>
                    <td align="center">{{ formatDateMethod(props.item.date, 'MM/DD/YYYY hh:mm') }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
        </v-container>
        <v-container class="pa-0" v-if="index === 1">
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="searchlog"
                  append-icon="search"
                  label="Search by Action / Name / Date Time"
                  hide-details
                ></v-text-field>
                 <v-spacer></v-spacer>
                 <v-spacer></v-spacer>
                 <v-spacer></v-spacer>
            </v-card-title>
              <v-data-table
                disable-initial-sort
                :headers="logHeaders"
                :items="Log"
                :search="searchlog"
                class="pf-data-table"
                ref="sortableTable"
                :pagination.sync="paginationLog"
                no-data-text="No logs to show"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.action }}</td>
                    <td>{{ props.item.entity }}</td>
                    <td>{{ JSON.parse(props.item.log).title }}</td>
                    <td class="log_info">
                      <p class="mb-0" v-if="props.item.log_info && props.item.log_info.type"> <span>Type</span>: {{ props.item.log_info && props.item.log_info.type ? props.item.log_info.type : '--' }}</p>
                      <p class="mb-0" v-if="props.item.log_info && props.item.log_info.action"> <span>Action</span>: {{ props.item.log_info && props.item.log_info.action ? props.item.log_info.action : '--' }}</p>
                      <p class="mb-0" v-if="props.item.log_info && props.item.log_info.edited"> <span>Edited</span>: {{ props.item.log_info && props.item.log_info.edited ? props.item.log_info.edited : '--' }}</p>
                      <p class="mb-0" v-if="props.item.log_info && props.item.log_info.start_time"> <span>Start Time</span>: {{ props.item.log_info && props.item.log_info.start_time ? formatDateMethod(props.item.log_info.start_time, 'MM/DD/YYYY hh:mm:ss a') : '--' }}</p>
                      <p class="mb-0" v-if="props.item.log_info && props.item.log_info.end_time"> <span>End Time</span>: {{ props.item.log_info && props.item.log_info.end_time ? formatDateMethod(props.item.log_info.end_time, 'MM/DD/YYYY hh:mm:ss a') : '--' }}</p>
                      <p class="mb-0" v-if="props.item.log_info && props.item.log_info.size"> <span>Size</span>: {{ props.item.log_info && props.item.log_info.size ? formatFileSize(parseInt(props.item.log_info.size)) : '--' }}</p>
                    </td>
                    <td>{{ formatDateMethod(props.item.createdAt, 'MM/DD/YYYY hh') }}</td>
                    <td :class="[props.item.type === 'Success'? '' : 'pointer']" @click="props.item.type === 'Success' ? '' : ErrorAlert(props.item)">{{ props.item.type }} </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
        </v-container>
        <v-container class="pa-0" v-if="index === 0">
          <v-card>
            <v-card-title>
              <v-layout wrap row class="mb-4">
                <v-flex sm3>
                  <v-text-field
                      v-model="searchSection"
                      append-icon="search"
                      label="Search by Section name"
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex sm2 offset-sm1>
                  <v-select v-if="cloneProject" v-model="cloneProject.archive_mode" :items="['Original', 'Converted']" label="Archive mode" class="custom-red"></v-select>
                </v-flex>
              <v-flex sm3>
                <div class="text-xs-right" v-if="projectObj">
                      <v-btn
                      :disabled="cloneProject.archive_mode !== projectObj.archive_mode ? false : true"
                      class="pf-btn pf-bg-teal"
                      dark
                      small
                      @click="updateMode"
                    >
                      <span>Re-generate Package</span>
                    </v-btn>
                </div>
              </v-flex>
              <v-flex sm3>
                <div class="text-xs-right">
                      <v-btn
                      color="pf-btn pf-bg-teal"
                      dark
                      small
                      @click="DownloadAll"
                    >
                      <span> {{ 'Download' }}</span>
                    </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
            <v-data-table
              v-model="selected"
              :search="searchSection"
              :headers="headers"
              :items="sectionList"
              select-all
              class="pf-data-table sections_class"
              ref="sortableTable"
              :pagination.sync="paginationSection"
              no-data-text="No section items to show"
            >
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    aria-sort="none"
                    class="text-xs-left"
                    :class="[header.text === 'Actions' ? 'text-xs-right' : header.text === 'Notes' ? 'text-xs-center' :'text-xs-left']"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                <td :active="props.selected" @click="props.selected = !props.selected">
                  <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                </td>
                <td align="left" width="50px">
                  <v-btn icon class="ma-0" v-if="props.expanded" @click="props.expanded = !props.expanded">
                    <v-icon size="22" color="grey darken-2">keyboard_arrow_up</v-icon>
                  </v-btn>
                  <v-btn icon class="ma-0" v-else @click="props.expanded = !props.expanded">
                    <v-icon size="22" color="grey darken-2">keyboard_arrow_down</v-icon>
                  </v-btn>
                </td>
                <td>{{ props.item.title }}</td>
                <td>{{ formatDateMethod(props.item.updatedAt, 'MM/DD/YYYY') }}</td>
                <td align="center">{{ props.item.description ? props.item.description : '--' }}</td>
                <td align="right" width="100px">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small class="mr-0 ml-0" v-on="on">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                        <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                        </template>
                          <span>More</span>
                        </v-tooltip>
                      </v-btn>
                    </template>
                    <v-list class="familyOptions">
                      <v-list-tile @click="downloadSection(props.item)" :disabled="!props.item.items || !props.item.items.length">
                        <v-list-tile-action>
                          <v-btn icon small class="mr-0 ml-0">
                            <v-icon size="22" color="grey darken-2">save_alt</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title >
                          Download
                        </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="deleteSection(props.item)">
                        <v-list-tile-action>
                          <v-btn icon small class="mr-0 ml-0">
                            <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title >
                          Delete
                        </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card flat>
                  <v-data-table
                      disable-initial-sort
                      :headers="innerTableHeaders"
                      :items="props.item.items"
                      class="inner_items"
                      ref="sortableTable"
                      :pagination.sync="pagination"
                      hide-actions
                      no-data-text="No items to show"
                    >
                    <template v-slot:items="props">
                      <tr width="100%">
                        <td> {{ props.item.type }} </td>
                        <td> {{ props.item.description ? props.item.description : '--' }} </td>
                        <td align="center"> {{ props.item.size ? `${ formatFileSize(parseInt(props.item.size)) }` : '--'}} </td>
                        <td align="center"> {{ props.item.type === 'Video' ? props.item.duration ? getDuration(props.item.duration) : '--' : '--' }} </td>
                        <td align="right" width="100px">
                          <v-btn icon class="ma-0" @click="deleteSectionItem(props.item)">
                            <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
       </v-tab-item>
      </v-tabs>
    </v-card>
     </v-container>
  </div>
</template>
<script>
/* global session store config */

import swal from 'sweetalert2';
import { getCollection, formatDate, remove, update, formatFileSize } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import $ from 'jquery';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import moment from 'moment';
const useragent = require('useragent');


export default {
  data: () => ({
    entity: 'Project',
    listType: ['Project Information', 'Log Information', 'Device Information'],
    selected: [],
    formatFileSize: formatFileSize,
    zip: {},
    searchlog: '',
    searchDeviceInfo: '',
    projectId: '',
    projectObj: {},
    humanId: null,
    ppn: null,
    accountId: null,
    config: config,
    headers: [
      { text: '', value: '', width: '50px', sortable: false },
      { text: 'Section Name', value: 'title', sortable: false, align: 'left' },
      { text: 'Updated On', value: 'updatedAt', sortable: false, align: 'left' },
      { text: 'Notes', sortable: false, align: 'left' },
      { text: 'Actions', width: '100px', sortable: false, align: 'right' },
    ],
    logHeaders: [
      { text: 'Action', value: 'action', sortable: false, align: 'left' },
      { text: 'Name', value: 'entity', sortable: false, align: 'left' },
      { text: 'Item Name', sortable: false, align: 'left' },
      { text: 'Log Info', sortable: false, align: 'left' },
      { text: 'Date / Time hh', value: 'createdAt', sortable: false, align: 'left' },
      { text: 'Status', sortable: false, align: 'left' },
    ],
    innerTableHeaders: [
      { text: 'Type', sortable: false, align: 'left' },
      { text: 'Comment', sortable: false, align: 'left' },
      { text: 'Size', sortable: false, align: 'center' },
      { text: 'Duration', sortable: false, align: 'center' },
      { text: 'Actions', width: '100px', sortable: false, align: 'right' }
    ],
    deviceInfoHeaders: [
      { text: 'Device', value: '', sortable: false, align: 'left' },
      { text: 'Brand', value: 'device_info.brand', align: 'left' },
      { text: 'Model', value: 'device_info.model', align: 'left' },
      { text: 'Memory', align: 'left' },
      { text: 'OS', value: 'os', align: 'center' },
      { text: 'Login Time', value: 'date', align: 'center' },
    ],
    pagination: {
      sortBy: 'sort_no', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    paginationInfo: {
      sortBy: 'date', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    paginationLog: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    paginationSection: {
      sortBy: 'sort_no', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    searchSection: '',
    sectionList: [],
    items: [],
    accountData: [],
    cloneProject: {},
    mainTab: 'tab-0'
  }),
  computed: {
    ...mapGetters(['']),
    exportExcelName () {
      return 'log_list' + moment.utc().format('MMDDYYYY');
    },
    Project: {
      get () {
        return store.state.Project;
      },
      set (value) {
        store.commit('setProject', value);
      }
    },
    Log: {
      get () {
        return store.state.Log;
      },
      set (value) {
        store.commit('setLog', value);
      }
    }
  },
  watch: {
    Project (newValue) {
      if (newValue) {
        this.projectObj = newValue.find((project) => project.id === this.projectId && this.accountId === project.account);
        if (this.projectObj && this.projectObj.section) {
          this.sectionList = this.projectObj.section.filter(section => section.section && section.section.items.length > 0);
          this.sectionList = this.sectionList.map(section => section.section);
        }
      }
    },
    Log (newLog) {
      if (newLog) {
        this.log = newLog.map(log => ({ ...log, createdAt: this.formatDateMethod(log.createdAt, 'MM/DD/YYYY hh:mm') }));
      }
    }
  },
  async created () {
    this.projectId = this.$route.params.id;
    this.accountId = this.$route.query.accountId;
    this.humanId = this.$route.query.humanId;
    this.ppn = this.$route.query.ppn;
    if (this.$route.query && this.$route.query.preUrl === '/projectList') {
      this.Project = [];
      this.getUserAccess();
    } else {
      if (this.$route.query.access) this.accountData = JSON.parse(JSON.stringify(this.$route.query.access));
      else this.getUserAccess();
    }
    await this.getAccountProjects();
    if (this.Project.length) {
      this.projectObj = await this.Project.find((project) => project.id === this.projectId);
      this.cloneProject = JSON.parse(JSON.stringify(this.projectObj));
      if (this.projectObj.section) {
        this.sectionList = await this.projectObj.section.filter(section => section.section);
        this.sectionList = await this.sectionList.map(section => section.section);
        /* Set the items => item.item */
        this.sectionList = await this.sectionList.map(section => {
          section.items = section.items.filter(item => item.item).map(item => item.item);
          return section;
        });
      }
    } else {
      this.$router.push({ name: 'VideoProject' });
    }
    this.getLog();
    if (this.$route.query.tab) {
      this.mainTab = `tab-${this.$route.query.tab}`;
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Sections');
  },
  methods: {
    async updateMode (deleteAction = false) {
      let payload = JSON.parse(JSON.stringify(this.cloneProject));
      payload.section = payload.section.map(section => ({ ...section, section: section.section.id }));
      payload.requested_from = 'ui';
      let { error, data } = await update('Project', payload, payload.id);
      if (error) {
        console.log('error', error);
      } else {
        this.projectObj.archive_mode = data.archive_mode;
        if (!deleteAction) {
          swal.fire({
            type: 'success',
            title: 'Project Archive Mode changed',
            showConfirmButton: false,
            timer: 2500
          });
        }
      }
    },
    getDuration (milliseconds) {
      const seconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      const formattedHours = hours > 0 ? `${String(hours).padStart(2, '0')}h ` : '';
      const formattedMinutes = minutes > 0 ? `${String(minutes).padStart(2, '0')}m ` : '';
      const formattedSeconds = `${String(remainingSeconds).padStart(2, '0')}s`;
      return formattedHours + formattedMinutes + formattedSeconds;
    },
    async getUserAccess () {
      let populate = [{ 'path': 'human', populate: { path: 'user', select: 'username access' }}];
      let where = { _id: this.accountId };
      let { error, data } = await getCollection('Account', true, 0, populate, where);
      if (error) {
        console.log(error);
      } else {
        if (data.length) {
          this.accountData = JSON.parse(JSON.stringify(data[0].human[0].user.access));
        }
      }
    },
    async getAccountProjects () {
      if (!this.Project.length) {
        let populate = [{ path: 'section.section', populate: 'items.item' }];
        let where = { account: this.accountId };
        let { error, data } = await getCollection('Project', true, 0, populate, where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Project = data;
          }
        }
      }
    },
    toggleAll () {
      if (this.selected.length) this.selected = [];
      else this.selected = this.sectionList.slice();
    },
    ErrorAlert (item) {
      swal.fire({
        title: `${item.entity} ${item.action} error.`,
        text: item.log,
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      });
    },
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    async getLog () {
      let where = { account: this.projectObj.account };
      let { error, data } = await getCollection('Log', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Log = data;
        }
      }
    },
    async deleteSectionItem (sectionItem) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            this.sectionList = await this.sectionList.map(section => {
              if (section.id === sectionItem.section) {
                // eslint-disable-next-line max-nested-callbacks
                section.items = section.items.filter(item => item.id !== sectionItem.id);
              }
              return section;
            });
            // eslint-disable-next-line max-nested-callbacks
            /* let deleteItemSection = this.sectionList.filter(section => section.items.find(item => item._id === sectionItem._id));
            deleteItemSection[0].items = deleteItemSection[0].items.filter(item => item._id !== sectionItem._id);
            let sectionPayload = JSON.parse(JSON.stringify(deleteItemSection[0]));
            let { error, data, status } = update('Section', sectionPayload, sectionPayload.id); */
            let { error, data, status } = remove('SectionItem', sectionItem._id);
            if (error) {
              console.log('error', error);
            } else {
              let index = this.cloneProject.section.findIndex(sectionObj => sectionObj.section.id === sectionItem.section);
              this.cloneProject.section[index].section.items = this.cloneProject.section[index].section.items.filter(item => item.id !== sectionItem.id);
              this.cloneProject.update_from === 'Complete' && this.updateMode(true);
              swal.fire(
                'Deleted!',
                `The section Item "${sectionItem.file_name}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    },
    async deleteSection (section) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Section', section.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.sectionList.indexOf(section);
              this.sectionList.splice(index, 1);
              this.cloneProject.section = this.cloneProject.section.filter(sectionObj => sectionObj.section.id !== section.id);
              this.cloneProject.update_from === 'Complete' && this.updateMode(true);
              swal.fire(
                'Deleted!',
                `The section "${section.title}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    },
    async downloadAszip (list, sectionObj) {
      /* Validate the file paths */
      let invalidItems = {};
      let validPath = false;
      sectionObj.items.forEach(item => {
        validPath = this.humanId && this.projectId && sectionObj.id && item.type && item.file_name && item.file_name.indexOf('.') > -1;
        if (!validPath) {
          if (invalidItems[sectionObj.title]) {
            invalidItems[sectionObj.title].push(item.file_name);
          } else {
            invalidItems[sectionObj.title] = [item.file_name];                
          }
        }
      });
      let invalidKeys = Object.keys(invalidItems);
      if (invalidKeys.length) {
        let errorMessage = `The following file paths having problems, please check and try again.<br>`;
        for (let i = 0; i < invalidKeys.length; i++) {
          errorMessage += `Section: ${invalidKeys[i]}<br>`;
          errorMessage += invalidItems[invalidKeys[i]].map(x => `- ${x}<br>`);
        }
        swal.fire({
          type: 'error',
          title: 'Invalid file(s)',
          html: errorMessage,
          showConfirmButton: true,
          allowOutsideClick: true
        });
        return;
      }
      swal.fire({
        type: 'info',
        title: 'Please wait preparing for the download...',
        showConfirmButton: false,
        allowOutsideClick: false
      });
      let final = [...list];
      let zip = new JsZip();
      let Photos = zip.folder('Photos');
      let Videos = zip.folder('Videos');
      let NotesFileName = `${sectionObj.title}.txt`;
      let NotesFileContent = sectionObj.description ? sectionObj.description : '';
      if (NotesFileContent) {
        zip.file(NotesFileName, NotesFileContent);
      }
      let count = 0;
      let errorFiles = `The following file paths having problems, please check and try again.</br>`;
      let errorFlag = false;
      let zipName =  sectionObj.title + '.zip';
      if (final.length !== 0) {
        let error = false;
        try {
          final.forEach(function (url) {
            let filename = url.split('/').pop();
            let newUrl = '';
            let hostHttps = window.location.origin.indexOf('https');
            if (hostHttps === -1) {
              newUrl = url.replace('https', 'http');
            }
            else {
              newUrl = url;
            }
            filename = filename.split('::')[0];
            let itemDescription = newUrl.split('::');
            let findType = itemDescription[0].split('/').indexOf('photos');
            JSZipUtils.getBinaryContent(itemDescription[0], function (err, data) {
              count++;
              if (count === final.length) {
                if (err) {
                  errorFlag = true;
                  errorFiles += `${itemDescription[0].split('/').pop()}</br>`;
                }
                if (errorFlag) {
                  swal.fire({
                    type: 'error',
                    title: 'Download Failed!',
                    html: errorFiles,
                    showConfirmButton: true,
                    allowOutsideClick: true
                  });
                  return;
                }
              }
              if (err) {
                errorFlag = true;
                errorFiles += `${itemDescription[0].split('/').pop()}</br>`;
              } else {
                let textFileName = filename.split('.').slice(0, -1).join('');
                if (findType === -1) {
                  Videos.file(filename, data, { binary: true });
                  if (itemDescription[1]) {
                    Videos.file(`${textFileName}.txt`, itemDescription[1]);
                  }
                } else {
                  Photos.file(filename, data, { binary: true });
                  if (itemDescription[1]) {
                    Photos.file(`${textFileName}.txt`, itemDescription[1]);
                  }
                }
                if (count === final.length) {
                  swal.close();
                  swal.fire({
                    type: 'success',
                    title: 'Your section items are downloading, please wait...',
                    showConfirmButton: true,
                    allowOutsideClick: true
                  });
                  zip.generateAsync({ type: 'blob' }).then(function (content) {
                    saveAs(content, zipName);
                    swal.close();
                  });
                }
              }
            });
          });
        } catch (e) {
          swal.fire({
            type: 'error',
            title: 'Download Failed!',
            text: 'Not able to download files, please check your files in the section "' + sectionObj.title + '" and try again.',
            showConfirmButton: true,
            allowOutsideClick: true
          });
          return;
        }
      }
    },
    async DownloadAll () {
      if (this.selected.length) {
        this.selected = await this.selected.sort((a, b) => a.sort_no - b.sort_no);
        /* Validate the file paths */
        let invalidItems = {};
        this.selected.forEach(section => {
          let path = this.config.s3BucketPath + this.config.s3Domain + '/' + this.humanId + '/VideoProject/' + this.projectId + '/' + section.id + '/';
          let validPath = false;
          section.items.forEach(item => {
            validPath = this.humanId && this.projectId && section.id && item.type && item.file_name && item.file_name.indexOf('.') > -1;
            if (!validPath) {
              if (invalidItems[section.title]) {
                invalidItems[section.title].push(item.file_name);
              } else {
                invalidItems[section.title] = [item.file_name];                
              }
            }
          });
        });
        let invalidKeys = Object.keys(invalidItems);
        if (invalidKeys.length) {
          let errorMessage = `The following file paths having problems, please check and try again.<br>`;
          for (let i = 0; i < invalidKeys.length; i++) {
            errorMessage += `Section: ${invalidKeys[i]}<br>`;
            errorMessage += invalidItems[invalidKeys[i]].map(x => `- ${x}<br>`);
          }
          swal.fire({
            type: 'error',
            title: 'Invalid file(s)',
            html: errorMessage,
            showConfirmButton: true,
            allowOutsideClick: true
          });
          return;
        }
        swal.fire({
          type: 'info',
          title: 'Please wait preparing for the download...',
          showConfirmButton: false,
          allowOutsideClick: false
        });
        let zip = new JsZip();
        let orderTextFileContext = await this.selected.map(section => `${section.sort_no}. ${section.title} \n`);
        zip.file('section_orders.txt', orderTextFileContext.join(''));
        let zipName =  this.ppn + '.zip';
        let arrayLength = this.selected.length;
        let itemFilename = null;
        let fileFolder = null;
        let archiveMode = this.projectObj && this.projectObj.archive_mode ? this.projectObj.archive_mode : 'Converted';

        for (let index = 0; index < this.selected.length; index++) {
          try {
            let path = this.config.s3BucketPath + this.config.s3Domain + '/' + this.humanId + '/VideoProject/' + this.projectId + '/' + this.selected[index].id + '/';

            // eslint-disable-next-line no-loop-func
            let List = this.selected[index].items.map(item => {
              itemFilename = item.file_name;
              fileFolder = 'original';        
              if (archiveMode === 'Converted') {
                itemFilename = item.converted && item.converted_file_name ? item.converted_file_name : itemFilename;
                fileFolder = item.converted && item.type === 'Video' ? 'converted' : fileFolder;
              }
              return `${path}${item.type.toLowerCase()}s/${fileFolder}/${itemFilename}::${item.description ? item.description : ''}`;
            });

            let final = [...List];
            let Photos = zip.folder(`${this.selected[index].title}/Photos`);
            let Videos = zip.folder(`${this.selected[index].title}/Videos`);
            let Notes = zip.folder(`${this.selected[index].title}`);
            let NotesFileName = `${this.selected[index].title}.txt`;
            let NotesFileContent = this.selected[index].description ? this.selected[index].description : '';
            if (NotesFileContent) {
              Notes.file(NotesFileName, NotesFileContent);
            }
            let sectionData = {};
            if (final.length !== 0) {
              // eslint-disable-next-line no-loop-func
              await Promise.all(final.map(async (url) => {
                let filename = url.split('/').pop();
                let newUrl = '';
                let hostHttps = window.location.origin.indexOf('https');
                if (hostHttps === -1) {
                  newUrl = url.replace('https', 'http');
                }
                else {
                  newUrl = url;
                }
                filename = filename.split('::')[0];
                let itemDescription = newUrl.split('::');
                let findType = itemDescription[0].split('/').indexOf('photos');
                let data;
                if (index === arrayLength - 1) {
                  data = await JSZipUtils.getBinaryContent(itemDescription[0]);
                } else {
                  data = JSZipUtils.getBinaryContent(itemDescription[0]);
                }
                let textFileName = filename.split('.').slice(0, -1).join('');
                if (findType === -1) {
                  Videos.file(filename, data, { binary: true });
                  if (itemDescription[1]) {
                    Videos.file(`${textFileName}.txt`, itemDescription[1]);
                  }
                } else {
                  Photos.file(filename, data, { binary: true });
                  if (itemDescription[1]) {
                    Photos.file(`${textFileName}.txt`, itemDescription[1]);
                  }
                }
              }));
            }
            if (index === arrayLength - 1) {
              swal.close();
              swal.fire({
                type: 'success',
                title: 'Your section items are downloading, please wait...',
                showConfirmButton: false,
                allowOutsideClick: false
              });
              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipName);
                swal.close();
              });
            }
          } catch (e) {
            swal.fire({
              type: 'error',
              title: 'Download Failed!',
              text: 'Not able to download files, please check your files in the section "' + this.selected[index].title + '" and try again.',
              showConfirmButton: true,
              allowOutsideClick: true
            });
            return;
          }
        }
      } else {
        swal.fire({
          title: 'No section selected',
          text: 'Please select at least one section to download',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        });
      }
    },
    async downloadSection (itemsArray) {
      let path = this.config.s3BucketPath + this.config.s3Domain + '/' + this.humanId + '/VideoProject/' + this.projectId + '/' + itemsArray.id + '/';
      let filename = null;
      let fileFolder = null;
      let archiveMode = this.projectObj && this.projectObj.archive_mode ? this.projectObj.archive_mode : 'Converted';
      let List = await itemsArray.items.map(item => {
        filename = item.file_name;
        fileFolder = 'original';        
        if (archiveMode === 'Converted') {
          filename = item.converted && item.converted_file_name ? item.converted_file_name : filename;
          fileFolder = item.converted && item.type === 'Video' ? 'converted' : fileFolder;
        }
        return `${path}${item.type.toLowerCase()}s/${fileFolder}/${filename}::${item.description ? item.description : ''}`;
      });
      await this.downloadAszip(List, itemsArray);
    },
    backToProjectsList () {
      if (this.$route.query.preUrl) 
      { this.$router.push({ name: 'allProjects' }) }
      else {
        let humnanId = {
          id: this.projectObj.account,
          human: this.$route.query.humanId,
          access: this.$route.query.access,
          ppn: this.$route.query.ppn,
          accountId: this.$route.query.accountId
        };
        this.$router.push({ name: 'VideoProject', params: { item: humnanId }});
      }
    },
  }
};
</script>
<style scoped>

.title {
  background: #019d8c !important;
  color: #fff;
}

.rounded-corner {
    border-radius: 5px;
}

.desc {
  min-height: 20px;
}

.pointer { 
   cursor: pointer;
}

#sections >>> .v-tabs__item--active {
  background: #319d8c !important;
  color: #fff !important;
}

#sections >>> .v-tabs__bar.theme--light {
  margin-bottom: 2px !important;
}

#sections >>> .pf-data-table.sections_class th > i{
  display: none;
}

#sections >>> .pf-data-table.sections_class .accent--text {
  color: #319d8c !important;
  caret-color: #319d8c !important;
}

#sections >>> .v-datatable__expand-col.v-datatable__expand-col--expanded {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

#sections >>> .v-datatable__expand-content {
  border: 1px solid #319d8c !important;;
}

#sections >>> .v-tabs__div.border_left_right {
  border-right: 1px solid grey !important;
  border-left: 1px solid grey !important;
}

#sections >>> .log_info span {
  display: inline-block;
  width: 70px;
  padding-top: 1px;
  padding-bottom: 1px;
}

#sections >>> .log_info p {
  padding-top: 1px;
  padding-bottom: 1px;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: lightgray !important;
  color: #fff !important;
}

#sections >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

#sections >>> .custom-red .v-input--selection-controls__input div {
  color: #4caf50;
    caret-color: #4caf50;
}

</style>



// WEBPACK FOOTER //
// src/pages/VideoProject/adminSection.vue